module.exports = __webpack_public_path__ + "static/img/repair.4f236d96.png";